import { DefaultResponse } from "@shared/dtos/responses/commonResponses.dto"
import {
  LoginRequest,
  OnboardingStatusQuery,
  PublicSetupMfaRequest,
  PublicTotpConfirmRequest,
} from "@shared/zod/schemas/requests/auth"
import {
  LoginAdditionalStepResponse,
  LoginResponse,
  OnboardingStatusResponse,
  TotpSetupResponse,
} from "@shared/zod/schemas/responses/auth"

import { axiosPublic } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const login = (req: LoginRequest): Promise<LoginResponse | LoginAdditionalStepResponse> => {
  return axiosPublic({
    url: "/public/auth/login",
    method: "post",
    data: req,
  }).then((resp) => resp.data)
}

export const publicTotpSetup = (req: PublicSetupMfaRequest): Promise<TotpSetupResponse> => {
  return axiosPublic({
    url: "/public/auth/totp/setup",
    method: "post",
    data: req,
  }).then((resp) => resp.data)
}

export const publicTotpConfirm = async (req: PublicTotpConfirmRequest): Promise<void> => {
  await axiosPublic({
    url: "/public/auth/totp/confirm",
    method: "post",
    data: req,
  })
  return undefined
}

/**
 * Fetches the current onboarding status for a given account creation token
 * and user identifier (username or email).
 * Requires a token and at least one identifier for security.
 * @param query - The account creation token and username/email from the onboarding URL
 * @returns The current onboarding step
 */
export const onboardingStatus = async (query: OnboardingStatusQuery): Promise<OnboardingStatusResponse> => {
  const resp = await axiosPublic({
    url: "/public/auth/onboarding/status",
    params: query,
    method: "get",
  })
  return resp.data
}

export const confirmAccess = async (token: string): Promise<DefaultResponse> => {
  const { data } = await axiosPublic({
    url: "/public/auth/login/confirmaccess",
    params: { token },
    method: "post",
  })
  return data
}
